import styled from "styled-components";
import colors from "../../assets/styles/colors";

export const ApSecureContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 44px 20px 15px 20px;
  background: ${colors.bgGray};
`;

export const ApSecureWrapper = styled.div`
  height: 100%;
`;

export const ApSecureHeader = styled.div``;

export const ApSecureHeaderArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ApSecureHeaderTitle = styled.small`
  font-size: 12px;
  color: ${colors.textSecondary};
`;

export const ApSecureContent = styled.div`
  display: flex;
  justify-content: ${prop => prop.active ? 'center' : 'space-between'};
`;

export const ApSecureOpeningInfo = styled.div`
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ApSecureIcon = styled.div`
  width: 67px;
  height: 67px;
  background: ${colors.bgTertiary};
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ApSecureTitle = styled.h5`
  color: ${colors.textPrimary};
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.03em;
  margin-top: 20px;
`;

export const ApSecureParagraph = styled.p`
  color: ${colors.textPrimary};
  font-size: 16px;
  margin-top: 20px;
  line-height: 23px;
`;

export const ApSecureButtons = styled.div`
  display: flex;
  margin-top: 20px;

  & > button:first-child {
    margin-right: 20px;
  }
`;

export const ApSecureListContainer = styled.div`
  display: flex;
  margin-right: 10px;

  &:last-child {
    margin-right: 0px;
  }
`;

export const ApSecureCategoryList = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  max-height: 500px;
  overflow-y: scroll;
  width: 100%;
  border-radius: 8px;
  padding: 5px;

  &:first-child {
    padding: 0px;
    width: 240px;
    background: ${colors.bgGray};
  }

  background: ${colors.white};
`;

export const ApSecureCategoryListItem = styled.div`
  cursor: pointer;
  font-size: 14px;
  line-height: 20px;
  font-weight: bold;
  color: ${colors.textPrimary};
  padding: 12px 8px;
  border-radius: 8px;
  background: ${prop => prop.active ? colors.white : 'transparent'};
`;

export const ApSecureOptions = styled.div`
  background: ${colors.white};
  padding: 10px;
  border-radius: 8px;
`;

export const ApSecureActiveCategory = styled.p`
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.textPrimary};
`;

export const ApSecureCheckbox = styled.div`
  border-radius: 8px;
  align-items: center;
  display: flex;
  margin-top: 20px;
`;

export const ApSecureField = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1.5px solid ${colors.textHyperlink};
  background: ${prop => prop.checked ? colors.textHyperlink : colors.white};
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ApSecureLabel = styled.h6`
  color: ${colors.textPrimary};
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
`;

export const ApSecureCategorySelectedItem = styled.div`
  display: flex;
  padding: 15px 10px;
  border-bottom: solid 1px ${colors.grayLight};
  display: grid;
  grid-template-columns: 1fr 20px;

  &:last-child {
    border-bottom: none;
  }

  svg {
    cursor: pointer;  
  }
`;

export const ApSecureCategorySelectedItemLabel = styled.label``;

export const ApSecureFooter = styled.div`
  padding-left: 240px;
  margin-top: 30px;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
`;
